import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {Table, Button} from 'reactstrap';
import parse from 'html-react-parser';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { serviceUrl, tokenName, iName } from '../../constant';
import { getToken } from '../../globalfunction';

class Funding extends Component {
	state={
		project:[],
		summary:[],
		// this.onSubmit()=this.onSubmit.bind(this),
	}
	async investedListFetch(){
		getToken();
		try {
			let project2 = await axios.get(`${serviceUrl}prj/invested/list?limit=10&page_no=1`);
			const project = project2.data.data.items[0].upgrades;
		  	this.setState ({project});
		  	console.log(project);
		
			// Work with the response...
		} catch (err) {
			if (err.response) {
				// The client was given an error response (5xx, 4xx)
				console.log(err.response.data);
       			console.log(err.response.status);
        		console.log(err.response.headers);
			} else if (err.request) {
				// The client never received a response, and the request was never left
				console.log(err.request);
			} else {
				// Anything else
				console.log('Error', err.message);
			}
		}
	  }
	  async investedSummaryListFetch(){
		getToken();
		try {
			let project2 = await axios.get(`${serviceUrl}prj/summary/invested/list?limit=10&page_no=1`);
			const summary = project2.data.data.items[0].upgrades;
		  	this.setState ({summary});
		  	console.log(summary);
		
			// Work with the response...
		} catch (err) {
			if (err.response) {
				// The client was given an error response (5xx, 4xx)
				console.log(err.response.data);
       			console.log(err.response.status);
        		console.log(err.response.headers);
			} else if (err.request) {
				// The client never received a response, and the request was never left
				console.log(err.request);
			} else {
				// Anything else
				console.log('Error', err.message);
			}
		}
	  }

	componentDidMount() {
		this.investedListFetch();
		this.investedSummaryListFetch();

     const $ = window.$;

     $( 'body' ).addClass( 'bg-gray' );

 	}

    render() {

        // let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="signin-page-area pd-top-100 ">
			  <div className="container">
			    <div className="row justify-content-center">
					
				{/* <ToastContainer
				position="top-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
				/> */}
				<h5>Transaction Table </h5>
			      <Table responsive>
					<thead>
						<tr>
						<th>
							Date
						</th>
						<th>
							Project Name
						</th>
						<th>
							City
						</th>
						<th>
							Amount Invested
						</th>
						<th>
							Partake
						</th>
						<th>
							Action
						</th>
						</tr>
					</thead>
					<tbody>
						{this.state.project.map((project)=>{
							return(
							<tr>
								<td>
									{project.date}
								</td>
								<td>
								{project.title}
								</td>
								<td>
								{project.city}
								</td>
								<td>
								&#8377;  {project.invested_amount}
								</td>
								<td>
								{project.partake}
								</td>
								<td>
									<Button color="primary"><Link to={`/f/project/${project.project_id}`}>Visit</Link></Button>
								</td>
						</tr>
						)
						})}
						
					</tbody>
					</Table>
					<h5>Summary Table </h5>
			      <Table responsive>
					<thead>
						<tr>
						<th>
							Project Name
						</th>
						<th>
							City
						</th>
						<th>
							Total Amount
						</th>
						<th>
							Total Partake
						</th>
						<th>
							Action
						</th>
						</tr>
					</thead>
					<tbody>
						{this.state.summary.length && this.state.summary.map((project)=>{
							return(
							<tr>
								<td>
								{project.title}
								</td>
								<td>
								{project.city}
								</td>
								<td>
								&#8377;  {project.invested_amount}
								</td>
								<td>
								{project.partake}
								</td>
								<td>
									<Button color="primary"><Link to={`/invested/${project.project_id}`}>Visit</Link></Button>
								</td>
						</tr>
						)
						})}
						
					</tbody>
					</Table>
			    </div>
			  </div>
			  
			</div>
        }
}

export default withRouter(Funding)